import { createContext, useContext } from 'react'
import { ShopCheckoutSideBarResponse } from '../models'

interface ShopCartContextProps {
  cartData: ShopCheckoutSideBarResponse | null
  setCartData: React.Dispatch<React.SetStateAction<ShopCheckoutSideBarResponse | null>>
  emptyCart: () => void
}

export const ShopCartContext = createContext<ShopCartContextProps | undefined>(undefined)

export const useShopCartContext = (): ShopCartContextProps => {
  const context = useContext(ShopCartContext)
  if (!context) {
    throw new Error('useShopCartContext must be used within a ShopCartProvider')
  }
  return context
}
